import { Component, computed, inject, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeCotop } from '@app/models/entity.model';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { HeroVImagesComponent } from '@app/components/hero-v-images/hero-v-images.component';
import { ContentLinkService } from '@app/services/contentLinks.service';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

@Component({
  selector: 'mobi-node-cotop',
  templateUrl: './node-cotop.component.html',
  styleUrls: ['./node-cotop.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    BreadcrumbComponent,
    HeroVImagesComponent,
    ParagraphLoaderComponent,
  ],
})
export class NodeCotopComponent {
  readonly entity = input.required<NodeCotop>();
  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
